import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, labelModes, popperPlacements, sizes, states } from '@/utils'

import button from '@/components/button'
import create from '@/components/generator/search/create'
import preloader from '@/components/preloader'

const baseClass = 'search-generator'

function renderSearchField(h, options) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.restData[options.name].find.filter.$search,
        label: this.getTranslate('commons.labels.search'),
        afterIcon: icons.search,
        name: 'search',
        suffix: this.restData[options.name].find.pagination.total,
        loading: this.$_loading,
        clearable: true,
        labelMode: labelModes.hidden,
        dense: true,
        details: false
      },
      on: {
        input: event => {
          this.restData[options.name].find.filter.$search = event
        }
      }
    }
  )
}

function renderActionTitle(h, path) {
  return h(
    'div',
    {
      class: `${baseClass}__action-title`
    },
    [ this.getTranslate(path) ]
  )
}
function renderActionSwitch(h, value) {
  return h(
    components.switch,
    {
      props: {
        value
      }
    }
  )
}
function renderIsActiveAction(h, options) {
  if (options.filterByIsActive) {
    return h(
      'div',
      {
        class: `${baseClass}__action`,
        on: {
          click: () => {
            this.setIsActive(!this.isActive)
          }
        }
      },
      [
        renderActionTitle.call(this, h, 'commons.filters.isActive.hide'),
        renderActionSwitch.call(this, h, this.isActive)
      ]
    )
  }
}

function renderFilterAction(h) {
  if (this.$slots.filter || typeof this.$scopedSlots.filter === 'function') {
    return h(
      'div',
      {
        class: `${baseClass}__action`,
        on: {
          click: () => {
            this.showFilter = !this.showFilter
          }
        }
      },
      [
        renderActionTitle.call(this, h, 'commons.filters.filter.show'),
        renderActionSwitch.call(this, h, this.showFilter)
      ]
    )
  }
}
function renderCreateSlot(h, options) {
  if (typeof this.$scopedSlots.create === 'function') {
    return this.$scopedSlots.create()
  } else if (this.$slots.create) {
    return this.$slots.create
  } else {
    return h(
      create(options),
      {
        props: {
          maxWidth: this.maxWidth,
          title: this.titleCreate
        }
      }
    )
  }
}
function renderReportSlot() {
  if (typeof this.$scopedSlots.report === 'function') {
    return this.$scopedSlots.report()
  } else {
    return this.$slots.report
  }
}
function renderActionMenu(h, options) {
  return h(
    components.menu,
    {
      props: {
        rounded: true,
        offsetDistance: -37,
        placement: popperPlacements['bottom-end']
      }
    },
    [
      h(
        button,
        {
          props: {
            icon: icons.more_vert,
            mode: buttonModes.flat
          },
          slot: 'activator'
        }
      ),

      h(
        components.list,
        {
          props: {
            dense: true,
            rounded: true
          }
        },
        [
          renderIsActiveAction.call(this, h, options),
          renderFilterAction.call(this, h, options),
          renderCreateSlot.call(this, h, options),
          renderReportSlot.call(this, h, options)
        ]
      )
    ]
  )
}

function renderSearch(h, options) {
  return h(
    'div',
    {
      class: `${baseClass}__search`
    },
    [
      renderSearchField.call(this, h, options),
      renderActionMenu.call(this, h, options)
    ]
  )
}

function renderFilterSlot(h, options) {
  if (typeof this.$scopedSlots.filter === 'function') {
    return this.$scopedSlots.filter({ filter: this.restData[options.name].find.filter })
  }

  return this.$slots.filter
}
function renderFilter(h, options) {
  if (this.showFilter) {
    return h(
      'div',
      {
        class: `${baseClass}__filter`
      },
      [ renderFilterSlot.call(this, h, options) ]
    )
  }
}

function renderTab(h, value) {
  const isCurrentTab = this.currentTab === value
  let mode = buttonModes.clear
  let color
  if (isCurrentTab) {
    mode = buttonModes.flat
    color = Colors.primary
  }

  return h(
    button,
    {
      props: {
        label: this.getTranslate(`commons.tabs.${value}`),
        size: sizes.small,
        mode,
        color
      },
      on: {
        click: () => {
          this.currentTab = value
        },
        dblclick: event => {
          event.preventDefault()
          this.setDefaultTab(value)
        }
      }
    }
  )
}
function renderTabs(h, options) {
  return h(
    'div',
    {
      class: `${baseClass}__types`
    },
    [ 'all', 'visited', 'favorites' ].map(type => {
      return renderTab.call(this, h, type, options)
    })
  )
}
function renderRefreshButton(h) {
  if (this.currentTab === 'all') {
    return h(
      button,
      {
        props: {
          icon: icons.refresh,
          size: sizes.small,
          mode: buttonModes.flat,
          loading: this.$_loading,
          disabled: this.$_loading
        },
        on: {
          click: () => {
            if (this.$_ready) {
              this.find()
            }
          }
        }
      }
    )
  }
}
function renderHeader(h, options) {
  return h(
    'div',
    {
      class: `${baseClass}__header`
    },
    [
      renderTabs.call(this, h, options),
      renderRefreshButton.call(this, h, options)
    ]
  )
}

function renderPreloader(h) {
  return h(
    'div',
    {
      class: 'preloader__holder pa-5'
    },
    [ h(preloader) ]
  )
}
function renderItem(h, item) {
  if (typeof this.$scopedSlots.default === 'function') {
    return this.$scopedSlots.default({
      item,
      loading: this.loadingItem[item.id]
    })
  }
}
function renderItems(h, options, items) {
  return h(
    components.list,
    {
      class: 'grid-gap--4',
      props: {
        dense: options.dense,
        transparent: true
      },
      key: this.currentTab
    },
    [
      items.map(item => {
        return renderItem.call(this, h, item)
      })
    ]
  )
}
function renderBody(h, options, items, trigger) {
  if (trigger) {
    return renderItems.call(this, h, options, items)
  } else {
    switch (this.currentTab) {
      case 'visited':
      case 'favorites': {
        if (this.$_loading[this.currentTab]) {
          return renderPreloader.call(this, h)
        }

        return h(components.empty)
      }
      case 'all':
      default: {
        switch (this.restData[options.name].find.state) {
          case states.loading: return renderPreloader.call(this, h)
          case states.ready:
          default: return h(components.empty)
        }
      }
    }
  }
}

function renderLoadMoreButton(h) {
  if (this.currentTab === 'all') {
    if (this.showLoadMore) {
      return h(
        'div',
        {
          class: 'fjcc facc'
        },
        [
          h(
            button,
            {
              props: {
                label: this.getTranslate('misc.loadMore'),
                mode: buttonModes.flat,
                color: Colors.primary,
                loading: this.$_loading,
                disabled: this.$_loading || !this.showLoadMore
              },
              on: { click: this.loadMore }
            }
          )
        ]
      )
    }
  }
}

function renderContentByType(h, options) {
  const { data, pagination } = this.restData[options.name].find
  switch (this.currentTab) {
    case 'visited':
    case 'favorites':
      return renderBody.call(this, h, options, this[this.currentTab], this[this.currentTab].length > 0)
    case 'all':
    default:
      return renderBody.call(this, h, options, data, pagination.total > 0)
  }
}
function renderScrollContent(h, options) {
  return h(
    'div',
    {
      class: `${baseClass}__scroll`,
      on: { scroll: this.onScroll }
    },
    [
      renderContentByType.call(this, h, options),
      renderLoadMoreButton.call(this, h)
    ]
  )
}

function renderContent(h, options) {
  return h(
    'div',
    {
      class: {
        [`${baseClass}__content`]: true,
        [`${baseClass}__content--filter`]: this.showFilter
      }
    },
    [
      renderSearch.call(this, h, options),
      renderFilter.call(this, h, options),
      renderHeader.call(this, h, options),
      renderScrollContent.call(this, h, options)
    ]
  )
}

export default function(h, options) {
  if (options.show || this.$_show) {
    return h(
      'div',
      {
        class: baseClass
      },
      [ renderContent.call(this, h, options) ]
    )
  }
}
